/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TruncatedText } from 'ca-ui-toolkit';
import { observer } from 'mobx-react';
import './DisplayTooltipInfo.scss';

@observer
class DisplayTooltipInfo extends Component {

	renderColumn(column, textPosition, columnClassName) {
		return	(
			<div className={columnClassName}>
				{column.map((columnInstance, key) => <div key={key} className='popover_rows'>
					<TruncatedText
						style={ { maxWidth: '100%' }}
						textAlign={textPosition}
						className='displayBoxRow'
						location="end"
						value={columnInstance}>
					</TruncatedText>
				</div>)}
			</div>);
	}

	//Renders the formatted text to be displayed in the popover when the compare line is moved.
	render() {
		return (
			<div className='displayBox' >
				<div className='crossHair'>
					{this.renderColumn(this.props.crossHairInfo[0], 'left', 'display_col1')}
					{this.renderColumn(this.props.crossHairInfo[1], 'right', 'display_col2')}
				</div>
			</div>
		);
	}
}

DisplayTooltipInfo.propTypes = {
	crossHairInfo: PropTypes.array
};

DisplayTooltipInfo.defaultProps = {
	crossHairInfo: []
};


export default DisplayTooltipInfo;



// WEBPACK FOOTER //
// ./src/js/components/display-tooltipinfo/DisplayTooltipInfo.js